module.exports = __webpack_public_path__ + "img/eu.295728e7.svg";